'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageKey = exports.getQuickReply = exports.getAllowUserInput = exports.getUrl = exports.getText = exports.getId = exports.getUse = exports.getType = exports.getTimetoken = exports.getTimestamp = exports.getThreadId = exports.getStatus = exports.getSource = exports.getSenderType = exports.getSenderId = exports.getMetadata = exports.getDescriptor = exports.getClientTs = exports.getChannel = exports.getAuditTimestamp = exports.getAgentId = undefined;
exports.getRichText = getRichText;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _underscore = require('underscore');

var _PubNubMessageKey = require('../../records/PubNubMessageKey');

var _PubNubMessageKey2 = _interopRequireDefault(_PubNubMessageKey);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAgentId = exports.getAgentId = (0, _getIn2.default)(_keyPaths.METADATA_AGENT_ID);
var getAuditTimestamp = exports.getAuditTimestamp = (0, _getIn2.default)(_keyPaths.METADATA_AUDIT_TIMESTAMP);
var getChannel = exports.getChannel = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_CHANNEL);
var getClientTs = exports.getClientTs = (0, _getIn2.default)(_keyPaths.CLIENT_TS);
var getDescriptor = exports.getDescriptor = (0, _getIn2.default)(_keyPaths.DESCRIPTOR);
var getMetadata = exports.getMetadata = (0, _getIn2.default)(_keyPaths.METADATA);
var getSenderId = exports.getSenderId = (0, _pipe2.default)((0, _getIn2.default)(_keyPaths.SENDER_ID), function (senderId) {
  return senderId && '' + senderId;
});
var getSenderType = exports.getSenderType = (0, _getIn2.default)(_keyPaths.SENDER_TYPE);
var getSource = exports.getSource = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_SOURCE);
var getStatus = exports.getStatus = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_STATUS);
var getThreadId = exports.getThreadId = (0, _getIn2.default)(_keyPaths.THREAD_ID);
var getTimestamp = exports.getTimestamp = (0, _getIn2.default)(_keyPaths.TIMESTAMP);
var getTimetoken = exports.getTimetoken = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_TIMETOKEN);
var getType = exports.getType = (0, _getIn2.default)(_keyPaths.METADATA_TYPE);
var getUse = exports.getUse = (0, _getIn2.default)(_keyPaths.DESCRIPTOR_USE);
var getId = exports.getId = (0, _getIn2.default)(_keyPaths.ID);
var getText = exports.getText = (0, _getIn2.default)(_keyPaths.TEXT);
var getUrl = exports.getUrl = (0, _getIn2.default)(_keyPaths.URL);
var getAllowUserInput = exports.getAllowUserInput = (0, _getIn2.default)(_keyPaths.ALLOW_USER_INPUT);
var getQuickReply = exports.getQuickReply = (0, _getIn2.default)(_keyPaths.QUICK_REPLY);

function getRichText(message) {
  return (0, _getIn2.default)(_keyPaths.RICH_TEXT, message) || (0, _underscore.escape)(getText(message));
}

/* getters that use other getters */
var getMessageKey = exports.getMessageKey = function getMessageKey(message) {
  return (0, _PubNubMessageKey2.default)({
    clientTs: getClientTs(message),
    senderId: getSenderId(message),
    senderType: getSenderType(message)
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/pubnubMessageGetters.js
// module id = 21
// module chunks = 2 3